import {mapGetters} from "vuex";
import Logout from "@/mixins/Logout";

export default {
    mixins: [Logout],
    computed: {
        ...mapGetters({
            companyInfoId: "getCompanyId",
            editCompanyInfoId: "getEditCompanyInfoId",
            isSiteAdminOrUser : "isSiteAdminOrUser",
            officesByCompanyInfo: "getOfficesByCompanyInfo",
            getEditOfficesByCompanyInfoId: "getEditOfficesByCompanyInfoId"
        }),
    },
    methods: {
        loadCompanyId(){
            // Primero intenta con companyInfoId (from user.companyInfo)
            if (this.companyInfoId) {
                return this.companyInfoId;
            }
            // Fallback a editCompanyInfoId (from editCompanyInfo)
            if (this.editCompanyInfoId) {
                return this.editCompanyInfoId;
            }
            // Si ambos fallan, loguea advertencia para debugging
            console.warn('[Utils][loadCompanyId] No companyId found in state.user.companyInfo or state.editCompanyInfo', {
                companyInfoId: this.companyInfoId,
                editCompanyInfoId: this.editCompanyInfoId,
                role: this.$store.state.user?.role
            });
            return null;
        },
        loadCompanyOffices(){
            return this.isSiteAdminOrUser ? this.officesByCompanyInfo : this.getEditOfficesByCompanyInfoId
        },
        isErrorText(data){
            return Boolean(data?.response?.data?.errorCode || data?.response?.status)
        },
        getErrorText(data) {
            if(!this.isErrorText(data)) {
                console.error('[APP][getErrorText] ERROR:', data)
                return ''
            }
            const errorCode = data?.response?.data?.errorCode || data?.response?.status
            this.errorForLogout(data?.response, data?.path)

            return errorCode
        },
        errorForLogout(errorCode, path) {
            if (errorCode?.status === 401) {
                setTimeout(() => {
                    this.logoutSession(path)
                }, 2000);
            }
        }
    }
};
